import { render, staticRenderFns } from "./ChangeNameThur.vue?vue&type=template&id=e5b7bed2&"
import script from "./ChangeNameThur.vue?vue&type=script&lang=js&"
export * from "./ChangeNameThur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports